export enum OnDemandStatus {
  None = 'none', // e.g. called outside of OD
  Ready = 'ready', // green, can be used w/ OD
  Warning = 'warning', // yellow, can be used w/ OD but may not be if not fired soon
  NotReady = 'not-ready', // red, cannot be used w/ OD without calibration shot(s)
}

// what should the front-end do when it receives this
export enum OnDemandStatusAction {
  RefreshSnapshot = 'refresh-snapshot',
  SnapshotProgress = 'snapshot-progress',
}
